<template>
    <div class="grid gap-4 [grid-template-columns:repeat(auto-fill,minmax(15rem,1fr))]">
        <NewHomeCard
            v-for="item in insights"
            :key="item.url"
            class="h-full"
            :card-type="CARD_TYPE.INSIGHTS"
            :subtitle="t('chat.home.insights.insightSubtitle')"
            :title="item.title || t('chat.home.insights.defaultTitle')"
            :analytics-title="item.title || INSIGHT_ANALYTICS_FALLBACK_TITLE"
            :cta-button-text="t('chat.home.insights.diveDeeper')"
            @cta-click="$emit('cta-click', { type: CARD_TYPE.INSIGHTS, url: item.url })">
            <template v-if="item.icon" #header>
                <i :class="item.icon" class="text-2xl text-ink-muted" aria-hidden="true"></i>
            </template>
            <template #content>
                <p class="body overflow-auto text-ink-muted fs-mask">{{ item.content }}</p>
            </template>
        </NewHomeCard>
        <NewHomeCard
            v-for="topic in suggestedTopics"
            :key="topic.prompt_id"
            class="h-full"
            :card-type="CARD_TYPE.SUGGESTED_TOPICS"
            :subtitle="t('chat.home.insights.suggestedTopicSubtitle')"
            :title="topic.external_name"
            :content="topic.content ?? undefined"
            :cta-button-text="t('chat.home.insights.diveDeeper')"
            @cta-click="$emit('cta-click', { type: CARD_TYPE.SUGGESTED_TOPICS, url: topic.start_url })" />
    </div>
</template>

<script setup lang="ts">
import NewHomeCard from "~vue/ChatHome/NewHomeCard.vue";
import type { HomeCard, HomepageInsight, SuggestedTopic } from "~vue/types/chat_home";
import { CARD_TYPE } from "~vue/utils/homeCards";
import { useI18n } from "vue-i18n";

interface Props {
    suggestedTopics?: SuggestedTopic[];
    insights?: HomepageInsight[];
}

withDefaults(defineProps<Props>(), { suggestedTopics: () => [], insights: () => [] });
defineEmits<{ "cta-click": [card: HomeCard] }>();

const { t } = useI18n();

// HOMEPAGE_CARD_SHOWN keeps logging the English fallback title in every language.
const INSIGHT_ANALYTICS_FALLBACK_TITLE = "This week I noticed";
</script>
